import { ROOM } from "../Actions/Utilites";


const INITIAL_STATE = {
  // Add Menu
  addRoomLoading: false,
  addRoomSuccess: false,
  addRoomFailure: false,
  addRoomError: null,

  //   Get ALl Menu
  getAllRoomLoading: false,
  getAllRoomSuccess: false,
  getAllRoomFailure: false,
  getAllRoomError: null,
  getAllRoom: [],

  //   Get Menu
  getRoomLoading: false,
  getRoomSuccess: false,
  getRoomFailure: false,
  getRoomError: null,
  getRoom: [],

  //   Update Menu
  updateRoomLoading: false,
  updateRoomSuccess: false,
  updateRoomFailure: false,
  updateRoomError: null,
  updateRoom: [],

  //   Delete Menu
  deleteRoomLoading: false,
  deleteRoomSuccess: false,
  deleteRoomFailure: false,
  deleteRoomError: null,
  deleteRoom: [],
};

export const RoomReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Add Menu
    case ROOM.ADD_ROOM_REQUEST:
      return {
        ...state,
        addRoomLoading: true,
        addRoomSuccess: false,
        addRoomFailure: false,
        addRoomError: null,
      };
    case ROOM.ADD_ROOM_SUCCESS:
      return {
        ...state,
        addRoomLoading: false,
        addRoomSuccess: true,
        addRoomFailure: false,
        addRoomError: null,
        getAllRoom: [...state.getAllRoom, action.payload.result],
      };
    case ROOM.ADD_ROOM_FAILURE:
      return {
        ...state,
        addRoomLoading: false,
        addRoomSuccess: false,
        addRoomFailure: true,
        addRoomError: action.payload,
      };

    //   Get All Menu
    case ROOM.GET_ALL_ROOM_REQUEST:
      return {
        ...state,
        getAllRoomLoading: true,
        getAllRoomSuccess: false,
        getAllRoomFailure: false,
        getAllRoomError: null,
      };
    case ROOM.GET_ALL_ROOM_SUCCESS:
      return {
        ...state,
        getAllRoomLoading: false,
        getAllRoomSuccess: true,
        getAllRoomFailure: false,
        addAllMenuError: null,
        getAllRoom: action.payload.result,
      };
    case ROOM.GET_ALL_ROOM_FAILURE:
      return {
        ...state,
        getAllRoomLoading: false,
        getAllRoomSuccess: false,
        getAllRoomFailure: true,
        getAllRoomError: action.payload,
      };

    // Get Menu
    case ROOM.GET_ROOM_REQUEST:
      return {
        ...state,
        getRoomLoading: true,
        getRoomSuccess: false,
        getRoomFailure: false,
        getRoomError: null,
      };
    case ROOM.GET_ROOM_SUCCESS:
      return {
        ...state,
        getRoomLoading: false,
        getRoomSuccess: true,
        getRoomFailure: false,
        addRoomError: null,
        getRoom: action.payload.result,
      };
    case ROOM.GET_ROOM_FAILURE:
      return {
        ...state,
        getRoomLoading: false,
        getRoomSuccess: false,
        getRoomFailure: true,
        getRoomError: action.payload,
      };

    // Update Note
    case ROOM.UPDATE_ROOM_REQUEST:
      return {
        ...state,
        updateRoomLoading: true,
        updateRoomSuccess: false,
        updateRoomFailure: false,
        updateRoomError: null,
      };
    case ROOM.UPDATE_ROOM_SUCCESS:
      return {
        ...state,
        updateRoomLoading: false,
        updateRoomSuccess: true,
        updateRoomFailure: false,
        updateRoomError: null,
        updateRoom: action.payload,
      };
    case ROOM.UPDATE_ROOM_FAILURE:
      return {
        ...state,
        updateRoomLoading: false,
        updateRoomSuccess: false,
        updateRoomFailure: true,
        updateRoomError: action.payload,
      };

    // Delete Note
    case ROOM.DELETE_ROOM_REQUEST:
      return {
        ...state,
        deleteRoomLoading: true,
        deleteRoomSuccess: false,
        deleteRoomFailure: false,
        deleteRoomError: null,
      };
    case ROOM.DELETE_ROOM_SUCCESS:
      const result = state.getAllRoom.filter(
        (note) => note.id !== action.payload.result
      );
      return {
        ...state,
        deleteRoomLoading: false,
        deleteRoomSuccess: true,
        deleteRoomFailure: false,
        deleteRoomError: null,
        getAllRoom: result,
      };
    case ROOM.DELETE_ROOM_FAILURE:
      return {
        ...state,
        deleteRoomLoading: false,
        deleteRoomSuccess: false,
        deleteRoomFailure: true,
        deleteRoomError: action.payload,
      };

    default:
      return state;
  }
};
